import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getRequest } from "../../axios";

const ProofOfDeliveryInvoice = () => {
  const [invoice, setInvoice] = useState(null); // State to store invoice data
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoiceData = async () => {
      setLoading(true); // Set loading to true before the API call
      console.log("Starting API call");

      try {
        const response = await getRequest(
          "package-model/package-by-driver-route/?route_id=1&driver_id=3&page=1&ordering=id&pagesize=10&search=KJh78438K&total=0"
        );

        console.log("API Response:", response); // Log the entire response
        setInvoice(response.data.data.packages[0]); // Set the invoice data
      } catch (err) {
        console.error("Error fetching data:", err); // Log any errors
      } finally {
        setLoading(false); // Set loading to false after the request
        console.log("API call complete");
      }
    };

    fetchInvoiceData(); // Call the function when the component mounts
  }, []);

  const downloadPDF = async () => {
    const invoiceElement = document.getElementById("invoice");
    const tableElement = document.getElementById("invoice-table");

    if (!invoiceElement) {
      console.error("Invoice element not found");
      return;
    }

    try {
      // Helper to ensure images are loaded
      const waitForImagesToLoad = (element) => {
        return Promise.all(
          Array.from(element.querySelectorAll("img")).map((img) =>
            img.complete
              ? Promise.resolve()
              : new Promise((resolve) => (img.onload = resolve))
          )
        );
      };

      // Wait for images to load in the invoice
      await waitForImagesToLoad(invoiceElement);

      // Generate PDF from the invoice
      const canvas = await html2canvas(invoiceElement, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
      });
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 190; // PDF width for the image
      const pageHeight = 297; // A4 page height
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 10; // Initial top margin
      pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add pages for overflowing invoice content
      while (heightLeft > 0) {
        pdf.addPage();
        position = heightLeft - imgHeight;
        pdf.addImage(imgData, "JPEG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Generate table content if available and separate by status
      if (tableElement) {
        await waitForImagesToLoad(tableElement);

        // Extract the rows from the table
        const rows = tableElement.querySelectorAll("tr");
        let deliveryTable = [];
        let failedTable = [];

        // Separate the rows based on status
        rows.forEach((row) => {
          const status = row.querySelector(".status"); // Assuming the status is in a column with class "status"
          if (status) {
            if (status.textContent === "Delivered") {
              deliveryTable.push(row);
            } else if (status.textContent === "Failed Delivery") {
              failedTable.push(row);
            }
          }
        });

        // Add Delivery table to the PDF on a new page
        if (deliveryTable.length > 0) {
          pdf.addPage(); // Start a new page for the Delivery status
          position = 10;
          pdf.text("Delivery Status", 10, position);

          // Add each row of the Delivery table
          deliveryTable.forEach((row, index) => {
            position += 10; // Move down for each row
            pdf.text(row.textContent, 10, position);
          });
        }

        // Add Failed table to the PDF on another new page
        if (failedTable.length > 0) {
          pdf.addPage(); // Start a new page for the Failed status
          position = 10;
          pdf.text("Failed Status", 10, position);

          // Add each row of the Failed table
          failedTable.forEach((row, index) => {
            position += 10; // Move down for each row
            pdf.text(row.textContent, 10, position);
          });
        }
      }

      // Save the PDF
      pdf.save(`Proof_of_Delivery_${invoice?.number || "Document"}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  // Function to wait for all images to load
  const waitForImagesToLoad = async (element) => {
    const images = Array.from(element.getElementsByTagName("img"));
    await Promise.all(
      images.map((img) => {
        return new Promise((resolve, reject) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = reject;
          }
        });
      })
    );
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        textAlign: "start",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f4f7fc",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <div
        id="invoice"
        style={{
          maxWidth: "850px",
          margin: "10px auto",
          background: "#ffffff",
          padding: "15px",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            backgroundColor: "#f95c19",
            color: "#ffffff",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "26px",
              fontWeight: "bold",
              color: "#ffffff",
            }}
          >
            Proof of Delivery
          </h1>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0",
            padding: "10px",
            backgroundColor: "#f9f9f9",
          }}
        >
          {/* Customer Details */}
          <div style={{ flex: 1, marginRight: "20px" }}>
            <h4 style={{ fontSize: "16px" }}>Customer Details</h4>
            <p>
              <strong>Name:</strong> {invoice?.customer_name}
            </p>
            <p>
              <strong>Address:</strong> {invoice?.customer_address}
            </p>
            <p>
              <strong>Contact:</strong> {invoice?.customer_phone}
            </p>
            <p>
              <strong>Email:</strong> {invoice?.customer_email}
            </p>
          </div>

          {/* Vertical Line */}
          <div
            style={{
              borderLeft: "2px solid #ddd",
              height: "auto", // Ensure it takes the height of the content
              margin: "0 10px",
            }}
          ></div>

          {/* Invoice Details */}
          <div style={{ flex: 1 }}>
            <h4 style={{ fontSize: "16px" }}>Invoice Details</h4>
            <p>
              <strong>Invoice No:</strong> bac123
            </p>
            <p>
              <strong>Date:</strong> {invoice?.status_change_time}
            </p>
            <p>
              <strong>Status:</strong> {invoice?.status}
            </p>
          </div>
        </div>

        {/* Table */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <thead>
            <tr>
              <th
                colSpan="2"
                style={{
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#f95c19",
                  color: "#ffffff",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid #ddd",
                }}
              >
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Tracking No. */}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Tracking No.
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.hawb}
              </td>
            </tr>
            {/* Company Name */}
            <tr>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Company Name
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.company_name}
              </td>
            </tr>
            {/* Shipper Address */}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Shipper Address
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.shipper_address}
              </td>
            </tr>
            {/* Destination Address */}
            <tr>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Destination Address
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.customer_address}
              </td>
            </tr>

            {/* Latitude */}
            <tr>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Latitude
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.coordinates.latitude}
              </td>
            </tr>
            {/* Longitude */}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Longitude
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.coordinates?.longitude}
              </td>
            </tr>
            {/* Weight */}
            <tr>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Weight
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.volume_weighted}
              </td>
            </tr>
            {/* Count */}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Count
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.count}
              </td>
            </tr>
            {/* Landed */}
            <tr>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Landed
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.landed}
              </td>
            </tr>
            {/* Price */}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td
                style={{
                  padding: "15px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                Price
              </td>
              <td
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  color: "#555555",
                  border: "1px solid #ddd",
                }}
              >
                {invoice?.price}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ border: "2px solid #f95c19", marginTop: "500px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              position: "relative",
            }}
          >
            {/* Conditionally render either "Delivery" or "Failed" note */}
            {invoice?.package_photo_upload[0] && (
              <>
                <div style={{ position: "relative" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    }}
                    border="1"
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan="2"
                          style={{
                            textAlign: "left",
                            backgroundColor: "#f95c19",
                            color: "#ffffff",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            fontSize: "16px",
                            border: "1px solid #ddd",
                          }}
                        >
                          Delivery Note
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        {
                          label: "Destination Address",
                          value: invoice?.customer_address,
                        },
                        {
                          label: "Delivery Date",
                          value: invoice?.delivery_date,
                        },
                        {
                          label: "Delivery Time",
                          value: invoice?.status_change_time,
                        },
                        // {
                        //   label: "Force Reasons",
                        //   value: invoice.force_reasons,
                        // },
                        // { label: "Reasons", value: invoice.reasons },
                        // {
                        //   label: "Other Reasons",
                        //   value: invoice.other_reasons,
                        // },
                        {
                          label: "Latitude",
                          value:
                            invoice?.package_photo_upload[0]?.driver_latitude,
                        },
                        {
                          label: "Longitude",
                          value:
                            invoice?.package_photo_upload[0]?.driver_longitude,
                        },
                      ].map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: index % 2 === 0 ? "#fafafa" : "",
                          }}
                        >
                          <td
                            style={{
                              padding: "15px",
                              fontWeight: "bold",
                              fontSize: "15px",
                              color: "#555555",
                              border: "1px solid #ddd",
                            }}
                          >
                            {row.label}
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              fontSize: "15px",
                              color: "#555555",
                              border: "1px solid #ddd",
                            }}
                          >
                            {row.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Right Part: Signature */}
                <div
                  style={{
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    height: "100%",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      borderBottom: "1px solid #555555",
                      width: "201px",
                      position: "absolute",
                      bottom: "41px",
                      right: "0",
                      background: "white",
                    }}
                  >
                    <img
                      src={
                        invoice?.package_photo_upload[0]?.signature[0]
                          ?.signature
                      }
                      alt="Authorized Signature"
                      style={{
                        width: "100%",
                        maxWidth: "200px",
                        height: "auto",
                      }}
                    />
                    <p
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#555555",
                      }}
                    >
                      {invoice?.assigned_to?.name}
                    </p>
                  </div>
                </div>

                {/* Photos Section */}
                {Array.isArray(invoice?.package_photo_upload) &&
                invoice.package_photo_upload.some(
                  (photo) => photo?.photo_upload
                ) ? (
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        marginBottom: "10px",
                        padding: "15px",
                        backgroundColor: "#f9f9f9",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#333",
                          marginBottom: "15px",
                        }}
                      >
                        <i
                          style={{
                            color: "#171515",
                            marginRight: "8px",
                            fontSize: "22px",
                          }}
                          className="fas fa-camera-retro"
                        ></i>
                        Photos:
                        <hr />
                      </h3>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        {invoice.package_photo_upload
                          .filter((photo) => photo?.photo_upload)
                          .map((photo, index) => (
                            <img
                              key={index}
                              style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "8px",
                              }}
                              src={photo?.photo_upload}
                              alt={`Delivery Photo ${index + 1}`}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <p style={{ color: "#555", fontSize: "14px" }}>
                    No photos available.
                  </p>
                )}
              </>
            )}
            {invoice?.package_failed_delivery[0] && (
              <>
                <div style={{ position: "relative", marginTop: "500px" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    }}
                    border="1"
                  >
                    <thead>
                      <tr>
                        <th
                          colSpan="2"
                          style={{
                            textAlign: "left",
                            backgroundColor: "#f95c19",
                            color: "#ffffff",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            fontSize: "16px",
                            border: "1px solid #ddd",
                          }}
                        >
                          Failed Note
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        {
                          label: "Destination Address",
                          value: invoice?.customer_address,
                        },
                        {
                          label: "Date",
                          value: invoice?.status_change_time,
                        },
                        {
                          label: "Time",
                          value: invoice?.status_change_time,
                        },
                        {
                          label: "Force Reasons",
                          value:
                            invoice?.package_failed_delivery[0]?.force_reasons,
                        },
                        {
                          label: "Reasons",
                          value: invoice?.package_failed_delivery[0]?.reasons,
                        },
                        {
                          label: "Other Reasons",
                          value:
                            invoice?.package_failed_delivery[0]?.other_reasons,
                        },
                        {
                          label: "Latitude",
                          value:
                            invoice?.package_failed_delivery[0]
                              ?.driver_latitude,
                        },
                        {
                          label: "Longitude",
                          value:
                            invoice?.package_failed_delivery[0]
                              ?.driver_longitude,
                        },
                      ].map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: index % 2 === 0 ? "#fafafa" : "",
                          }}
                        >
                          <td
                            style={{
                              padding: "15px",
                              fontWeight: "bold",
                              fontSize: "15px",
                              color: "#555555",
                              border: "1px solid #ddd",
                            }}
                          >
                            {row.label}
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              fontSize: "15px",
                              color: "#555555",
                              border: "1px solid #ddd",
                            }}
                          >
                            {row.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Right Part: Signature */}
                {/* <div
                  style={{
                    justifyContent: "flex-end",
                    alignItems: "flex-start",
                    height: "100%",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "inline-block",
                      textAlign: "center",
                      borderBottom: "1px solid #555555",
                      width: "201px",
                      position: "absolute",
                      bottom: "41px",
                      right: "0",
                      background: "white",
                    }}
                  >
                    <img
                      src={
                        invoice.package_photo_upload[0].signature[0].signature
                      }
                      alt="Authorized Signature"
                      style={{
                        width: "100%",
                        maxWidth: "200px",
                        height: "auto",
                      }}
                    />
                    <p
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#555555",
                      }}
                    >
                      {invoice.assigned_to.name}
                    </p>
                  </div>
                </div> */}

                {/* Photos Section */}
                {Array.isArray(invoice?.package_failed_delivery) &&
                invoice.package_failed_delivery.some(
                  (photo) => photo?.photo_upload
                ) ? (
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        marginBottom: "10px",
                        padding: "15px",
                        backgroundColor: "#f9f9f9",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#333",
                          marginBottom: "15px",
                        }}
                      >
                        <i
                          style={{
                            color: "#171515",
                            marginRight: "8px",
                            fontSize: "22px",
                          }}
                          className="fas fa-camera-retro"
                        ></i>
                        Photos:
                        <hr />
                      </h3>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        {invoice.package_failed_delivery
                          .filter((photo) => photo?.photo_upload)
                          .map((photo, index) => (
                            <img
                              key={index}
                              style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "8px",
                              }}
                              src={photo.photo_upload}
                              alt={`Delivery Photo ${index + 1}`}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <p style={{ color: "#555", fontSize: "14px" }}>
                    No photos available.
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Download PDF Button */}
      <button
        onClick={downloadPDF}
        style={{
          display: "block",
          margin: "20px auto",
          padding: "10px 20px",
          backgroundColor: "#f95c19",
          color: "#ffffff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Download PDF
      </button>
    </div>
  );
};

const tableCellStyle = {
  padding: "10px",
  borderBottom: "1px solid #eeeeee",
  fontSize: "14px",
  color: "#555555",
};

export default ProofOfDeliveryInvoice;
